import React, { useEffect, useState } from "react";
import { injectModels } from "../../redux/injectModels";
import { useNavigate, useParams } from "react-router-dom";
import Modal from "react-bootstrap/Modal";

const ViewUser = ({ isOpen, id, closeModel, props }) => {
  const navigate = useNavigate();
  const [data, setData] = useState("");

  useEffect(() => {
    getUserswithEmail();
  }, []);
  const getUserswithEmail = async () => {
    props.application.setLoading(true);
    try {
      const res = await props.admin.getOneUser(id);
      if (res) {
        setData(res && res.user);
        console.log("one user data", res);
      }
      props.application.setLoading(false);
    } catch (error) {
      console.error("Failed to fetch users:", error);
      props.application.setLoading(false);
    }
  };

  const handleBack = () => {
    navigate("/User");
    closeModel();
  };

  return (
    <Modal
      show={isOpen}
      onHide={closeModel}
      size="md"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title>User Details</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <table className="table session_deatils_demo">
          <tbody>
            <tr>
              <th>User Name:</th>
              <td>{data.username}</td>
            </tr>
            <tr>
              <th>Email:</th>
              <td>{data.email}</td>
            </tr>
            <tr>
              <th>Phone Number:</th>
              <td>{data.phone_number}</td>
            </tr>
            <tr>
              <th>About:</th>
              <td>{data.about}</td>
            </tr>
            <tr>
              <th>Mac address:</th>
              <td>{data.mac_address}</td>
            </tr>
            <tr>
              <th>Address:</th>
              <td>{data.address}</td>
            </tr>
            <tr>
              <th>Job:</th>
              <td>{data.job}</td>
            </tr>
            <tr>
              <th>City:</th>
              <td>{data.city}</td>
            </tr>
            <tr>
              <th>Country:</th>
              <td>{data.country}</td>
            </tr>
            <tr>
              <th>State:</th>
              <td>{data.state}</td>
            </tr>
            <tr>
              <th>Postal Code:</th>
              <td>{data.postal_code}</td>
            </tr>
          </tbody>
        </table>
        <div
          style={{
            display: "flex",
            justifyContent: "end",
            alignItems: "center",
          }}
        >
          <button
            className="btn btn-secondary"
            style={{ marginTop: "20px" }}
            onClick={handleBack}
          >
            Back
          </button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default injectModels(["admin", "application"])(ViewUser);
